import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { toast } from "react-toastify";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultiSelectDropdown({
  options,
  placeholder,
  inputValue,
  maxOptions,
}) {
  const [selectValue, setSelectValue] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    if (value.length > 3 && maxOptions === "3") {
      toast.error("Maximum of 3 options are allowed", {
        position: "top-center",
        autoClose: 2500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else {
      setSelectValue(() => {
        const updatedValue =
          typeof value === "string" ? value.split(",") : value;
        inputValue(updatedValue);
        return updatedValue;
      });
    }
  };
  
  return (
    <div>
      <FormControl
        sx={{ m: 1, width: 300, mt: 3 }}
        className={selectValue.length === 0 ? "placeholder_Class" : ""}
      >
        <Select
          multiple
          displayEmpty
          value={selectValue}
          onChange={handleChange}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <em>{placeholder}</em>;
            }

            return selected.join(", ");
          }}
          MenuProps={MenuProps}
        >
          <MenuItem disabled>
            <em>{placeholder}</em>
          </MenuItem>
          {options.map((name) => (
            <MenuItem key={name.id} value={name.name}>
              <Checkbox checked={selectValue.indexOf(name.name) > -1} />
              <span>{name.name}</span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
